import React, { useState, useMemo } from 'react';
import ITagDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import Search from '../Search/Search';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

interface Group {
  id: Guid;
  name: string;
  color: string;
  tags: ITagDetail[];
}

interface Props {
  title: string;
  groups: Group[];
  onTagClick: (tag: ITagDetail) => void;
  iconClass: string;
  backgroundColor: string;
}

const Panel = ({
  title,
  groups,
  onTagClick,
  iconClass,
  backgroundColor
}: Props) => {
  const [searchValue, setSearchValue] = useState('');

  const filteredGroups = useMemo(() => {
    return groups.map((group) => ({
      ...group,
      tags: group.tags.filter((tag) =>
        tag.name.toLowerCase().includes(searchValue.toLowerCase())
      )
    }));
  }, [groups, searchValue]);

  return (
    <div className="tag-select-panel">
      <p className="title">{title}</p>

      <Search
        placeholder={'Search'}
        value={searchValue}
        onValueChange={setSearchValue}
      />

      <div className="content" style={{ backgroundColor }}>
        <div className="tags-container">
          {filteredGroups.map((group) =>
            group.tags.length > 0 ? (
              <div key={group.name} className="group">
                <Chip
                  key={group.id}
                  id={group.id}
                  name={group.name}
                  color={group.color}
                />
                <div className="tags">
                  {group.tags.map((tag) => (
                    <div key={tag.id} className="tag">
                      <span className="tag-name">{tag.name}</span>
                      <i
                        className={iconClass}
                        onClick={() => onTagClick(tag)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

export default Panel;
